"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const complex_plugin_1 = require("complex-plugin");
const overdue_1 = __importDefault(require("../../api/overdue"));
const DescriptionList_vue_1 = __importDefault(require("./../DescriptionList.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'VehicleDetail',
    components: {
        DescriptionList: DescriptionList_vue_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            collapse: this.defaultCollapse,
            detail: {},
            description: [
                {
                    name: '车辆品牌',
                    prop: 'brandname'
                },
                {
                    name: '车辆型号',
                    prop: 'modelname'
                },
                {
                    name: '车辆价格',
                    prop: 'storageAmount'
                },
                {
                    name: '车架号',
                    prop: 'vinNo'
                },
                {
                    name: '车牌号',
                    prop: 'licensePlateNumber'
                },
                {
                    name: '发动机型号',
                    prop: 'engineNumber'
                },
                {
                    name: '排放',
                    prop: 'liter'
                },
                {
                    name: '入库时间',
                    prop: 'storageTime'
                },
                {
                    name: '发动机编号',
                    prop: 'engineNo'
                },
                {
                    name: '颜色',
                    prop: 'carColour'
                },
                {
                    name: '驾驶室',
                    prop: 'cabForm'
                },
                {
                    name: '厢货融资额',
                    prop: 'reservedField1'
                },
                {
                    name: '高栏融资额',
                    prop: 'reservedField2'
                },
                {
                    name: '液压尾板融资额',
                    prop: 'reservedField3'
                },
                {
                    name: '装具费',
                    prop: 'tablewareFee'
                }
            ]
        };
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getDetail();
                }
            }
        }
    },
    methods: {
        getDetail() {
            if (this.id) {
                overdue_1.default.overdueVehicleInfo.require({
                    contractId: this.id
                }).then((res) => {
                    if (res.data.data) {
                        this.detail = res.data.data || {};
                    }
                    else {
                        complex_plugin_1.notice.showMsg('获取车辆信息失败！', 'error');
                    }
                });
            }
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
